<template>
  <el-dialog title="行程日志" :visible.sync="visible" width="660px">
    <div v-loading="loading" class="box">
      <el-timeline v-if="data.length">
        <el-timeline-item v-for="item in data" :key="item.id" :type="item.opLevel" :timestamp="item.createTime">
          {{ item.userType | enumTransfer(logUserTypeOpts) }} {{ item.userName }} {{ item.operate }}
        </el-timeline-item>
      </el-timeline>
      <div v-else-if="!loading" class="empty">暂无行程日志</div>
    </div>
  </el-dialog>
</template>

<script>
import { getRouteLogs } from "@/api";
import store from "@/store";

export default {
  computed: {
    logUserTypeOpts() {
      return store.state.enumMap["LOG_USER_TYPE"];
    }
  },
  data() {
    return {
      visible: false,
      data: [],
      loading: false
    };
  },
  methods: {
    show(routeId) {
      this.visible = true;
      this.loading = true;
      this.data = [];
      getRouteLogs(routeId).then((res) => {
        this.data = res.data || [];
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  height: 460px;
  overflow: auto;
  padding: 20px 10px;
}

.empty {
  color: #909399;
  text-align: center;
  padding-top: 80px;
}
</style>
